import React from "react"
import styled from "styled-components"
import { minWidth, when } from "utils"
import Icon from "icons"

export const ProductShoppableGrid = styled.div`
  position: relative;
  max-width: 100%;
  margin: 0 auto;

  ${minWidth.tablet`
    margin: 2rem auto;   
  `}
`

export const Carousel = styled.div`
  width: 100%;
`

export const ScrollableGrid = styled.div`
  display: flex;
  justify-content: center;
  display: -webkit-box;
  overflow-x: auto;
  scroll-behavior: smooth;
`

const Cards = styled.div`
  width: 23.2rem;
  margin: 2rem 1rem;
  border-radius: 0;
  display: flex;
  flex-direction: column;

  :first-child {
    margin-left: 0;
  }

  :last-child {
    margin-right: 0;
  }

  ${minWidth.hamburgerLarge`
    width: 20.8rem;
  `}
`

export const DesktopWrapper = styled(Cards)`
  display: none;

  ${minWidth.tablet`
    display: flex;
  `}
`

export const MobileWrapper = styled(Cards)`
  ${minWidth.tablet`
    display: none;
  `}
`

export const Headline = styled.h4`
  position: relative;
  font-size: 1.6rem;
  font-weight: 300;
  font-family: "Maax";
  color: ##222222;
  opacity: 0.7; 
  margin 2rem 0 0 1rem;

  ${minWidth.tablet`
    margin 2rem 0 0 3rem;
  `}

`

const ScrollLabel = styled.div`
  font-size: 1.6rem;
  line-height: 2.2rem;
`

export const Scroll = () => (
  <ScrollWrapper>
    <ScrollLabel>scroll</ScrollLabel>
    <ScrollArrowLineMobile viewBox="1 0 248 12" id="arrow-line-mobile" />
  </ScrollWrapper>
)

const ScrollWrapper = styled.div`
  position: relative;
  margin: 1rem 0 0 1rem;

  ${minWidth.tablet`
    display: none; 
  `}
`

const ScrollArrowLineMobile = styled(Icon)`
  ${minWidth.tablet`
    display: none;
  `}
`

const ArrowIconLeft = styled(Icon)`
  display: none;

  ${minWidth.tablet`
    display: block;
    position: absolute;
    top: 0;
    left: 64rem;
    transform: translateY(-50%)
    cursor: pointer;
    outline: none;
    z-index: 3;
    ${when("disabled")`
      color: #eee;
      pointer-events: none;
    `}
  `}
`

const ArrowIconRight = styled(Icon)`
  display: none;
  ${when("show")`
   display: block;
  `};

  ${minWidth.tablet`
    display: block;
    position: absolute;
    top: 1.8%;
    left: 68rem;
    transform: translateY(-50%) rotate(-180deg);
    cursor: pointer;
    outline: none;
    z-index: 3;
    ${when("disabled")`
      color: #eee;
      pointer-events: none;
    `}
`}
`

export const ArrowLeft = (props) => (
  <ArrowIconLeft id="carousel-arrow" width={18} height={18} {...props} />
)

export const ArrowRight = (props) => (
  <ArrowIconRight id="carousel-arrow" width={18} height={18} {...props} />
)
